import Axios from 'axios';
import { useEffect, useState } from 'react';

import * as Routes from '@/modules/routes';

export interface PickerOption {
  label: string;
  value: number;
}

interface ProgramData {
  code: string;
  full_title_with_edition: string;
  id: number;
}

// Loads the program list for the picker (alphabetical, non-archived) via the shared
// programs API, mapping each to a { value, label } option for the searchable select.
const usePrograms = () => {
  const [programs, setPrograms] = useState<PickerOption[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const path = Routes.plato_api_programs_path({
      alphabetical: true,
      non_archived: true,
      only: ['code', 'full_title_with_edition', 'id'],
    });

    Axios.get<{ data: ProgramData[] }>(path)
      .then(({ data }) => {
        setPrograms(data.data.map(p => ({ label: `[${p.code}] ${p.full_title_with_edition}`, value: p.id })));
      })
      .catch(() => setPrograms([]))
      .finally(() => setIsLoading(false));
  }, []);

  return { isLoading, programs };
};

export default usePrograms;
